// extracted by mini-css-extract-plugin
export default {"policyTiles":"InsuranceTiles_policyTiles__iMXux","tile":"InsuranceTiles_tile__vnzjr"};